






































import {
    ActionPhase,
    AdvisorNavigation,
    Component,
    ComponentConfig,
    ComponentStyle,
    ComponentStyleDefinition, FileUploadQuestion,
    FlowStep,
    FlowStepSubmitStatus,
    FlowStepType,
    InjectComponent,
    Navigation,
    Prop,
    QAFlowStepsNavigation,
    QuestionType,
    SectionType,
    Vue,
    VueComponent,
} from "@zoovu/runner-browser-api";
import {AnswersConfiguration, PagesNavigationAction} from "../configuration";
import {scrollToElement} from "./utils";
import {isScrollingDisabledThroughDataAttribute,} from "../plugins/data-attributes-reader/webdesign-context";

@Component({})
export default class PagesNavigationView extends Vue {
    @InjectComponent("PageSelectorView")
    pageSelectorView: VueComponent;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @ComponentConfig(AnswersConfiguration)
    answersConfiguration: AnswersConfiguration;

    @Prop()
    navigation: AdvisorNavigation;

    @Prop({default: true})
    showPageSelector: boolean;

    pagesNavigationAction = PagesNavigationAction;

    currentAction: PagesNavigationAction | null;

    get rootElementClass(): string {
        return "pages-navigation-wrapper";
    }

    get previousButtonClassList(): ReadonlyArray<Record<string, unknown>> {
        return [
            {
                "is-hidden": !this.navigation.hasPrevious
            }
        ]
    }

    get previousButtonStyle(): Record<string, unknown> | null {
        return !this.navigation.hasPrevious ? { visibility: "hidden" } : null;
    }

    get nextButtonIsHidden(): boolean {
        return !this.navigation.hasNext || this.isResultsSectionNext && (this.submitIsInProgress || this.wouldNotPassValidation);
    }

    get nextButtonClassList(): ReadonlyArray<string | Record<string, unknown>> {
        return [
            this.navigation.isFetching ? "navigation-next-in-progress" : "navigation-next-button",
            {
                "is-hidden": this.nextButtonIsHidden,
            }
        ]
    }

    get nextButtonStyle(): Record<string, unknown> | null {
        return this.nextButtonIsHidden ? { visibility: "hidden" } : null;
    }

    get shouldRenderSubmitButton(): boolean {
        if (this.isQaFlowStepsNavigation(this.currentSectionNavigation)) {
            return !this.currentSectionNavigation.hasNext &&
                this.currentFlowStep.type === FlowStepType.LEAD &&
                this.currentFlowStep.submitStatus === FlowStepSubmitStatus.NOT_SUBMITTED &&
                !this.currentFlowStep.questions[0].readOnly &&
                this.currentFlowStep.questions.some(q => q.isMandatory || !q.isUnanswered);
        }
        return false;
    }

    get submitIsInProgress(): boolean {
        if (this.isQaFlowStepsNavigation(this.currentSectionNavigation)) {
            return this.currentFlowStep.submitStatus === FlowStepSubmitStatus.SUBMIT_IN_PROGRESS;
        } else {
            return false;
        }
    }

    get wouldNotPassValidation(): boolean {
        if (this.isQaFlowStepsNavigation(this.currentSectionNavigation)) {
            return this.currentFlowStep.wouldNotPassValidation;
        } else {
            return false;
        }
    }

    get isQuestionnaire(): boolean {
        return this.navigation.currentSection.type === SectionType.QUESTIONNAIRE;
    }

    get isResultsSectionNext(): boolean {
        return this.isQuestionnaire &&
            !this.currentSectionNavigation.hasNext &&
            this.navigation.nextSectionType === SectionType.RESULTS_PAGE &&
            this.isResultSectionNextForDynamicFlow()
    }

    get currentSectionNavigation(): Navigation {
        return this.navigation.currentSection.navigation;
    }

    get currentFlowStep(): FlowStep {
        return this.currentSectionNavigation.currentFlowStep;
    }

    get answeredFileUploadQuestions(): ReadonlyArray<FileUploadQuestion> {
        return this.currentFlowStep.questions.filter(question => question.questionType === QuestionType.FILE_UPLOAD && !question.isUnanswered);
    }

    onClickBack(): void {
        this.navigation.back();
        this.scrollToTop();
    };

    onClickNext(): void {
        this.currentAction = PagesNavigationAction.NEXT;
        this.onClickAction();
    }

    onClickSubmit(): void {
        this.currentAction = PagesNavigationAction.SUBMIT;
        this.onClickAction();
    }

    onClickAction(): void {
        if (!this.currentAction) {
            return ;
        }

        if (!this.leadGenHasFilesToBeUploaded()) {
            this.triggerAction()
        } else {
            this.handleFileUpload();
        }
    }

    onClickRealSubmit(): void {
        if (this.isQaFlowStepsNavigation(this.currentSectionNavigation)) {
            this.currentSectionNavigation.finished();
        }
    }

    onClickRealNext(): void {
        if (this.navigation.isFetching) {
            return;
        }
        this.navigation.next();
        this.scrollToTop();
    }

    mounted() {
        this.$root.$on("files-uploaded", () => {
            this.fileUploadQuestionsCount -= 1;
            if (!this.fileUploadQuestionsCount) {
                this.triggerAction()
            }
        });
    }

    triggerAction(): void {
        if (this.currentAction === PagesNavigationAction.SUBMIT) {
            this.onClickRealSubmit();
        } else if (this.currentAction === PagesNavigationAction.NEXT) {
            this.onClickRealNext();
        }
    }

    leadGenHasFilesToBeUploaded(): boolean {
        return this.answeredFileUploadQuestions.some(question => question.selectedFiles.length > 0 && !question.fileUrls.length);
    }

    fileUploadQuestionsCount = 0;

    handleFileUpload(): void {
        this.answeredFileUploadQuestions.forEach(question => {
            this.fileUploadQuestionsCount += 1;
            question.uploadSelectedFiles();
        });
    }

    async scrollToTop(): Promise<void> {
        if (!this.$root.$el || !this.answersConfiguration.scrollToTop || isScrollingDisabledThroughDataAttribute) return;

        await this.$nextTick();

        const leadGen = this.$root.$el.querySelector('.multi-answer');
        const errorMessage = this.$root.$el.querySelector('.question-validation-message');
        scrollToElement((leadGen && errorMessage) as Element || (this.$root.$el as Element))
    }

    isQaFlowStepsNavigation(navigation): navigation is QAFlowStepsNavigation {
        return (<QAFlowStepsNavigation>navigation).finished !== undefined;
    }


    isResultSectionNextForDynamicFlow(): boolean {
        if (this.isQaFlowStepsNavigation(this.currentSectionNavigation) &&
            this.currentSectionNavigation.flowSteps[this.currentSectionNavigation.currentStepIndex].type === FlowStepType.DYNAMIC_BOX) {
            const currentIndex = this.currentSectionNavigation.currentStepIndex;
            return this.currentSectionNavigation.flowSteps[currentIndex].type === FlowStepType.DYNAMIC_BOX &&
                this.currentFlowStep &&
                this.currentFlowStep.isLastDynamicFlowStep
        }
        return true;
    }
}
